import {
  Users,
  Briefcase,
  CheckCircle,
  Clock,
  TrendingUp,
} from "lucide-react";

export default function Dashboard() {
  return (
    <div className="min-h-screen space-y-6">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">
            CRM Dashboard
          </h1>
          <p className="text-sm text-gray-500">
            Overview of sales, leads & activities
          </p>
        </div>
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm">
          + Add Lead
        </button>
      </div>

      {/* KPI SECTION */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">

        <div className="bg-white border rounded-lg p-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">Total Leads</p>
            <Users size={18} className="text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold mt-2">1,245</h2>
        </div>

        <div className="bg-white border rounded-lg p-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">Active Deals</p>
            <Briefcase size={18} className="text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold mt-2">326</h2>
        </div>

        <div className="bg-white border rounded-lg p-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">Tasks Pending</p>
            <Clock size={18} className="text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold mt-2">18</h2>
        </div>

        <div className="bg-white border rounded-lg p-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">Closed Deals</p>
            <CheckCircle size={18} className="text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold mt-2">84</h2>
        </div>

        <div className="bg-white border rounded-lg p-4">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">Revenue (Month)</p>
            <TrendingUp size={18} className="text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold mt-2">$42,500</h2>
        </div>

      </div>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">

        {/* SALES FUNNEL */}
        <div className="bg-white border rounded-lg p-6 xl:col-span-2">
          <h2 className="text-lg font-semibold mb-4">
            Sales Funnel
          </h2>

          <div className="space-y-4 text-sm">

            <div>
              <div className="flex justify-between text-gray-600">
                <span>New Leads</span>
                <span>420</span>
              </div>
              <div className="w-full bg-gray-200 h-2 rounded mt-1">
                <div className="bg-blue-600 h-2 rounded w-3/4"></div>
              </div>
            </div>

            <div>
              <div className="flex justify-between text-gray-600">
                <span>Qualified</span>
                <span>260</span>
              </div>
              <div className="w-full bg-gray-200 h-2 rounded mt-1">
                <div className="bg-blue-600 h-2 rounded w-2/3"></div>
              </div>
            </div>

            <div>
              <div className="flex justify-between text-gray-600">
                <span>Proposal Sent</span>
                <span>150</span>
              </div>
              <div className="w-full bg-gray-200 h-2 rounded mt-1">
                <div className="bg-blue-600 h-2 rounded w-1/2"></div>
              </div>
            </div>

            <div>
              <div className="flex justify-between text-gray-600">
                <span>Closed Won</span>
                <span>84</span>
              </div>
              <div className="w-full bg-gray-200 h-2 rounded mt-1">
                <div className="bg-green-600 h-2 rounded w-1/3"></div>
              </div>
            </div>

          </div>
        </div>

        {/* TASKS & ACTIVITIES */}
        <div className="bg-white border rounded-lg p-6">
          <h2 className="text-lg font-semibold mb-4">
            Today's Tasks
          </h2>

          <div className="space-y-3 text-sm text-gray-700">

            <div className="flex justify-between border-b pb-2">
              <span>Call client - ABC Corp</span>
              <span className="text-red-500">High</span>
            </div>

            <div className="flex justify-between border-b pb-2">
              <span>Send proposal to XYZ Ltd</span>
              <span className="text-yellow-500">Medium</span>
            </div>

            <div className="flex justify-between">
              <span>Follow-up email</span>
              <span className="text-green-600">Low</span>
            </div>

          </div>
        </div>

      </div>
{/* RECENT ACTIVITY */}
<div className="bg-white border rounded-lg p-6">
  <div className="flex justify-between items-center mb-6">
    <h2 className="text-lg font-semibold text-gray-800">
      Recent Activity
    </h2>
    <button className="text-sm text-blue-600 hover:underline">
      View All
    </button>
  </div>

  <div className="relative space-y-6">

    {/* Activity Item */}
    <div className="relative flex items-start">
      <div className="flex justify-between w-full">
        <div>
          <p className="text-sm text-gray-800">
            <span className="font-medium">John Smith</span> moved deal 
            <span className="font-medium text-blue-600"> "Website Redesign"</span> 
            to Proposal stage
          </p>
          <p className="text-xs text-gray-400 mt-1">2 hours ago</p>
        </div>
      </div>
    </div>

    {/* Activity Item */}
    <div className="relative flex items-start">
      <div className="flex justify-between w-full">
        <div>
          <p className="text-sm text-gray-800">
            New lead added: 
            <span className="font-medium text-green-600"> Sarah Lee</span>
          </p>
          <p className="text-xs text-gray-400 mt-1">5 hours ago</p>
        </div>
      </div>
    </div>

    {/* Activity Item */}
    <div className="relative flex items-start">
      <div className="flex justify-between w-full">
        <div>
          <p className="text-sm text-gray-800">
            Deal closed successfully for 
            <span className="font-medium text-orange-600"> $4,500</span>
          </p>
          <p className="text-xs text-gray-400 mt-1">Yesterday</p>
        </div>
      </div>
    </div>

  </div>
</div>


    </div>
  );
}
